import React from 'react';
import styled from 'styled-components';
import { AwardType } from '../../api';

const AwardIcon = styled(
  ({ type, className }: { type: AwardType; className?: string }) => {
    switch (type) {
      // Plays
      case 'bronze':
      case 'silver':
      case 'gold':
      case 'diamond': {
        const playType = type;
        return (
          <img
            className={className}
            alt={`${type}-award`}
            src={`/static/images/awards/${playType}.svg`}
          />
        );
      }

      // Listens
      case 'keen_listener':
      case 'scout':
      case 'digger':
      case 'master':
        return (
          <img
            className={className}
            style={{ paddingTop: '1rem' }}
            alt={`${type}-award`}
            src={`/static/images/awards/${type}.svg`}
          />
        );

      // Feedbacks
      case 'helper':
      case 'mentor':
      case 'expert':
      case 'guru':
        return (
          <img
            className={className}
            alt={`${type}-award`}
            src={`/static/images/awards/${type}.svg`}
          />
        );
      default:
        return (
          <img
            className={className}
            style={{ paddingTop: '1rem' }}
            alt="keen_listener-award"
            src="/static/images/awards/keen_listener.svg"
          />
        );
    }
  },
)``;

export default AwardIcon;
